import { render, staticRenderFns } from "./approval-category.vue?vue&type=template&id=53b4b2f2"
import script from "./approval-category.vue?vue&type=script&lang=ts"
export * from "./approval-category.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports